import React from 'react'
import { useDispatch } from 'src/state/redux'
import { DNAButton, DNAModal, RichText } from '@alucio/lux-ui'
import { DNAModalActions } from 'src/state/redux/slice/DNAModal/DNAModal'

interface CustomDeckAcknowledgementModalProps {
  value: string
}

const CustomDeckAcknowledgementModal:React.FC<CustomDeckAcknowledgementModalProps> = ({ value }) => {
  const dispatch = useDispatch()

  const closeModal = () => dispatch(DNAModalActions.closeModal())

  return (
    <DNAModal>
      <DNAModal.Body>
        <RichText.Anchor
          value={value}
        />
      </DNAModal.Body>
      <DNAModal.Confirmation>
        <DNAButton
          testID="confirmation-button"
          status = "primary"
          onPress={closeModal}
        >
          I understand
        </DNAButton>
      </DNAModal.Confirmation>
    </DNAModal>
  )
}

export default CustomDeckAcknowledgementModal
